module.exports = __webpack_public_path__ + "img/DSC_2702.9469aa6b.png";